
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dhbEh", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7Ndnw = parcelRequire("7Ndnw");


var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $dizL5 = parcelRequire("dizL5");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $6UqI3 = parcelRequire("6UqI3");


var $6uUjl = parcelRequire("6uUjl");


var $3IBnw = parcelRequire("3IBnw");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3jwuS = parcelRequire("3jwuS");


var $c54hr = parcelRequire("c54hr");

















var $9hlns = parcelRequire("9hlns");


var $9fBoq = parcelRequire("9fBoq");


var $al4VD = parcelRequire("al4VD");

const $ced39bfea5ef5993$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isLoading: isLoading, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz1rpy" : "_syazn7od",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLoading: isLoading, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz1rpy" : "_syazn7od",
            __cmplp.className
        ])
    });
});
const $ced39bfea5ef5993$var$CenterSpinner = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $ced39bfea5ef5993$export$9f275aff884e1431 = (0, $3u0dr.isReactCompilerActiveV1)() ? function ForgeContentToolsItem(t0) {
    const $ = (0, $frIzR.c)(16);
    const { extension: extension, onClick: onClick, isLoading: isLoading } = t0;
    let t1;
    if ($[0] !== extension || $[1] !== onClick) {
        t1 = (e)=>{
            e.stopPropagation();
            onClick(extension);
        };
        $[0] = extension;
        $[1] = onClick;
        $[2] = t1;
    } else t1 = $[2];
    const onClickCB = t1;
    const t2 = extension.id;
    let t3;
    if ($[3] !== extension) {
        t3 = (0, $9fBoq.extensionTitle)(extension);
        $[3] = extension;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== isLoading) {
        t4 = isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        }));
        $[5] = isLoading;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== isLoading || $[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, t3, t4);
        $[7] = isLoading;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== extension.id || $[12] !== isLoading || $[13] !== onClickCB || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $al4VD.ContentToolsItem), {
            id: t2,
            isDisabled: isLoading,
            label: t5,
            onClick: onClickCB
        });
        $[11] = extension.id;
        $[12] = isLoading;
        $[13] = onClickCB;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
} : function ForgeContentToolsItem({ extension: extension, onClick: onClick, isLoading: isLoading }) {
    const onClickCB = (0, $42omo.useCallback)((e)=>{
        e.stopPropagation();
        onClick(extension);
    }, [
        extension,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $al4VD.ContentToolsItem), {
        id: extension.id,
        isDisabled: isLoading,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, (0, $9fBoq.extensionTitle)(extension), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        }))),
        onClick: onClickCB
    });
};
$ced39bfea5ef5993$export$9f275aff884e1431.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired
};



var $9MrOn = parcelRequire("9MrOn");

const $0c33e41081c1500e$var$EXPERIENCE_NAME = (0, $irVI7.VIEW_PAGE_CONTENT_TOOLS_FORGE_EXPERIENCE);
function $0c33e41081c1500e$export$7cf22b806dbb23cb({ contentId: contentId, spaceKey: spaceKey, children: children, onLoadComplete: onLoadComplete, isDropdownMenuOpen: isDropdownMenuOpen, lazyLoaderPlaceholderComponent: lazyLoaderPlaceholderComponent = null }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext)); // Forge menu items are behaving a little different than other menu items. They show a loading spinner if one of them
    // is clicked. There are a few different cases that needs to be handled while a forge extension is being loaded:
    // 1. Show a loading spinner while an extension id being loaded.
    //    - Stop showing the loading spinner once the extension is loaded.
    //    - Close the dropdown menu once the extension is loaded.
    // 2. If dropdown menu is closed while an extension is being loaded then stop loading the extension.
    // If there's a selected extension then `loadExtension` state changes like this:
    // +----------+----------------------+------------------+
    // |isLoading |   isDropdownMenuOpen |    loadExtension |
    // +----------------------------------------------------+
    // |          |                      |                  |
    // | false    |   false              |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | false    |   true               |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | true     |   false              |    false         |  --> stop loading the extension
    // |          |                      |                  |
    // | true     |   true               |    true          |  --> keep loading the extension
    // +----------+----------------------+------------------+
    const [extension, showExtension] = (0, $42omo.useState)(null);
    const [isLoading, setLoading] = (0, $42omo.useState)(false);
    const loadExtension = extension && !(isLoading && !isDropdownMenuOpen);
    (0, $42omo.useEffect)(()=>{
        if (!loadExtension) {
            experienceTracker.abort({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
                reason: 'Canceled by user'
            });
            setLoading(false);
            showExtension(null);
        }
    }, [
        loadExtension,
        experienceTracker
    ]);
    const onLoadCompleteCB = (0, $42omo.useCallback)(()=>{
        onLoadComplete();
        setLoading(false);
    }, [
        onLoadComplete,
        setLoading
    ]);
    const onCloseCB = (0, $42omo.useCallback)(()=>{
        showExtension(null);
    }, [
        showExtension
    ]);
    const onForgeExtensionClick = (0, $42omo.useCallback)((ext)=>{
        experienceTracker.start({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
            id: ext.id,
            timeout: 10000
        });
        showExtension(ext);
        setLoading(true);
    }, [
        showExtension,
        setLoading,
        experienceTracker
    ]);
    // shows up when preloaded in SSR. Shows up again when SPA takes over bf all queries are loaded.
    const LazyLoader = (0, $42omo.useMemo)(()=>(0, $dizL5.lazyForgeUIExtensionsWithLoader)(()=>lazyLoaderPlaceholderComponent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MrOn.ContentToolsButton // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ), {
                isDisabled: !(window.__SSR_RENDERED__ || undefined)
            })), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, loadExtension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$ForgeUIExtensionLoader, {
        extension: extension,
        contentId: contentId,
        spaceKey: spaceKey,
        onLoadComplete: onLoadCompleteCB,
        onClose: onCloseCB
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LazyLoader, {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
        render: (extensions, loading, error)=>{
            if (loading) return children([]);
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).ECOSYSTEM
                });
                return children([]);
            }
            const result = extensions.map((ext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ced39bfea5ef5993$export$9f275aff884e1431), {
                    key: ext.id,
                    extension: ext,
                    onClick: onForgeExtensionClick,
                    isLoading: extension === ext
                }));
            return children(result);
        }
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c33e41081c1500e$var$InvisibleDiv = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0cglyw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
}); /**
     * LazyForgeUIExtension has its own loading spinner, however, we don't want to show it anywhere. We want to show a
     * loading spinner inside the menu item while loading the extension, and then close the menu once the loading is complete.
     * To accomplish that, we're rendering LazyForgeUIExtension inside an invisible div.
     * @param forgeExtension To be loaded.
     * @param contentId Passed down to ForgeUIExtension both contentId and spaceKey becomes available in the forge app with
     * `useProductContext` hook. For reference https://developer.atlassian.com/platform/forge/ui-hooks-reference/.
     * @param spaceKey Passed down to ForgeUIExtension.
     * @param onLoadComplete Triggered when the forge extension is loaded.
     * @param onClose Triggered when the rendered ModalDialog is closed. (Currently ContentAction forge component can only contain a ModalDialog)
     * @returns LazyForgeUIExtension inside an InvisibleDiv.
     * @constructor
     */ 
const $0c33e41081c1500e$var$ForgeUIExtensionLoader = (0, $3u0dr.isReactCompilerActiveV1)() ? function ForgeUIExtensionLoader(t0) {
    const $ = (0, $frIzR.c)(33);
    const { extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [t1] = (0, $ep3mz.usePageState)();
    const { routeName: routeName } = t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    let t2;
    let t3;
    if ($[0] !== setIsCloseMenuDisabled) {
        t2 = ()=>{
            setIsCloseMenuDisabled(true);
            return ()=>{
                setIsCloseMenuDisabled(false);
            };
        };
        t3 = [
            setIsCloseMenuDisabled
        ];
        $[0] = setIsCloseMenuDisabled;
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[3] !== activationId || $[4] !== contentId || $[5] !== createAnalyticsEvent || $[6] !== experienceTracker || $[7] !== extension || $[8] !== onLoadComplete || $[9] !== routeName || $[10] !== spaceAlias || $[11] !== spaceId) {
        t4 = ()=>{
            experienceTracker.succeed({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME
            });
            onLoadComplete();
            const appId = (0, $8a9Dm.getAppId)(extension);
            const analyticEvent = createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "invoked",
                    actionSubject: "forgeExtension",
                    actionSubjectId: appId,
                    containerType: "space",
                    containerId: spaceId,
                    objectType: (0, $hIaUw.getContentType)(routeName),
                    objectId: contentId,
                    source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    attributes: {
                        activationId: activationId,
                        appId: appId,
                        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                        moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                        spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                        spaceId: spaceId
                    }
                }
            });
            analyticEvent.fire();
        };
        $[3] = activationId;
        $[4] = contentId;
        $[5] = createAnalyticsEvent;
        $[6] = experienceTracker;
        $[7] = extension;
        $[8] = onLoadComplete;
        $[9] = routeName;
        $[10] = spaceAlias;
        $[11] = spaceId;
        $[12] = t4;
    } else t4 = $[12];
    const onInitialRender = t4;
    if (!spaceKey) return null;
    const t5 = extension.id;
    const t6 = isLivePage ? "live" : null;
    let t7;
    if ($[13] !== routeName) {
        t7 = (0, $hIaUw.getContentType)(routeName);
        $[13] = routeName;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== contentId || $[16] !== t6 || $[17] !== t7) {
        t8 = {
            id: contentId,
            subtype: t6,
            type: t7
        };
        $[15] = contentId;
        $[16] = t6;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    const t9 = spaceKey || spaceAlias;
    let t10;
    if ($[19] !== spaceId || $[20] !== t9) {
        t10 = {
            key: t9,
            id: spaceId
        };
        $[19] = spaceId;
        $[20] = t9;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] !== t10 || $[23] !== t8) {
        t11 = {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            content: t8,
            space: t10
        };
        $[22] = t10;
        $[23] = t8;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== onClose || $[26] !== setIsCloseMenuDisabled) {
        t12 = ()=>{
            setIsCloseMenuDisabled(false);
            onClose();
        };
        $[25] = onClose;
        $[26] = setIsCloseMenuDisabled;
        $[27] = t12;
    } else t12 = $[27];
    let t13;
    if ($[28] !== extension || $[29] !== onInitialRender || $[30] !== t11 || $[31] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContentActionForgeApp), {
            key: t5,
            app: extension,
            extensionData: t11,
            onInitialRender: onInitialRender,
            onTearDown: t12
        }));
        $[28] = extension;
        $[29] = onInitialRender;
        $[30] = t11;
        $[31] = t12;
        $[32] = t13;
    } else t13 = $[32];
    return t13;
} : function ForgeUIExtensionLoader({ extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [{ routeName: routeName }] = (0, $ep3mz.usePageState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    (0, $42omo.useEffect)(()=>{
        // Ensures the MoreActions dialog remains opened while the Forge app is running
        // Without this, interactions with any portals from UI Kit components will close the menu which closes the Forge app
        setIsCloseMenuDisabled(true);
        return ()=>{
            setIsCloseMenuDisabled(false);
        };
    }, [
        setIsCloseMenuDisabled
    ]);
    const onInitialRender = (0, $42omo.useCallback)(()=>{
        experienceTracker.succeed({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME
        });
        onLoadComplete();
        const appId = (0, $8a9Dm.getAppId)(extension);
        const analyticEvent = createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'invoked',
                actionSubject: 'forgeExtension',
                actionSubjectId: appId,
                containerType: 'space',
                containerId: spaceId,
                objectType: (0, $hIaUw.getContentType)(routeName),
                objectId: contentId,
                source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                attributes: {
                    activationId: activationId,
                    appId: appId,
                    moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                    spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                    spaceId: spaceId
                }
            }
        });
        analyticEvent.fire();
    }, [
        onLoadComplete,
        experienceTracker,
        activationId,
        createAnalyticsEvent,
        contentId,
        spaceAlias,
        spaceId,
        extension,
        routeName
    ]);
    if (!spaceKey) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContentActionForgeApp // this key is required to enable user switch in between different forge apps during loading of an extension
    ), {
        key: extension.id,
        app: extension,
        extensionData: {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            // This ts ignore can be removed once the ff is cleaned up.
            // @ts-ignore FIXME `type` is declared by `extensionData` to be required for `content`
            content: {
                id: contentId,
                subtype: isLivePage ? 'live' : null,
                type: (0, $hIaUw.getContentType)(routeName)
            },
            space: {
                key: spaceKey || spaceAlias,
                id: spaceId
            }
        },
        onInitialRender: onInitialRender,
        onTearDown: ()=>{
            setIsCloseMenuDisabled(false);
            onClose();
        }
    }));
};
$0c33e41081c1500e$var$ForgeUIExtensionLoader.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    onLoadComplete: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["ForgeContentTools"] = $0c33e41081c1500e$export$7cf22b806dbb23cb;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("5WBm9"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("dmhac"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("hy6SH"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("jeVp9"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("2iVl7"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("a83DI"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("iOId4"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("lWIx1"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("kxJWh"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("acptf"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("kkEob"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("ayUlM"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("5WBm9", function(module, exports) {

let $453f58b911881f6f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $453f58b911881f6f$var$load("2YffH"),
    $453f58b911881f6f$var$load("8Kivm"),
    $453f58b911881f6f$var$load("fCnmZ"),
    $453f58b911881f6f$var$load("6bYkZ"),
    $453f58b911881f6f$var$load("iQ0Jm"),
    $453f58b911881f6f$var$load("coJiW"),
    $453f58b911881f6f$var$load("9MSTM"),
    $453f58b911881f6f$var$load("aYx1O"),
    $453f58b911881f6f$var$load("h4Nf7"),
    $453f58b911881f6f$var$load("7f9Fz"),
    $453f58b911881f6f$var$load("8YSo7"),
    $453f58b911881f6f$var$load("39eyQ"),
    $453f58b911881f6f$var$load("2spqH"),
    $453f58b911881f6f$var$load("gWSdF"),
    $453f58b911881f6f$var$load("6FuHS"),
    $453f58b911881f6f$var$load("eyaRC"),
    $453f58b911881f6f$var$load("g9CVe"),
    $453f58b911881f6f$var$load("aeEUI"),
    $453f58b911881f6f$var$load("hRUX7"),
    $453f58b911881f6f$var$load("g4oYs"),
    $453f58b911881f6f$var$load("6wr18"),
    $453f58b911881f6f$var$load("kjZZD"),
    $453f58b911881f6f$var$load("a71qb"),
    $453f58b911881f6f$var$load("awqCy"),
    $453f58b911881f6f$var$load("kHOMt"),
    $453f58b911881f6f$var$load("hhss7"),
    $453f58b911881f6f$var$load("61fdm"),
    $453f58b911881f6f$var$load("HRcBH"),
    $453f58b911881f6f$var$load("nbjnv"),
    $453f58b911881f6f$var$load("Wowvf"),
    $453f58b911881f6f$var$load("jlSv2"),
    $453f58b911881f6f$var$load("1UUrt"),
    $453f58b911881f6f$var$load("jSdjl"),
    $453f58b911881f6f$var$load("l2EUC"),
    $453f58b911881f6f$var$load("kWZnd"),
    $453f58b911881f6f$var$load("92LGf"),
    $453f58b911881f6f$var$load("let0D"),
    $453f58b911881f6f$var$load("joFPh"),
    $453f58b911881f6f$var$load("6M36W"),
    $453f58b911881f6f$var$load("ffEVr"),
    $453f58b911881f6f$var$load("kUbUu"),
    $453f58b911881f6f$var$load("2PePB"),
    $453f58b911881f6f$var$load("1W4KB"),
    $453f58b911881f6f$var$load("lnKog"),
    $453f58b911881f6f$var$load("9ftJe"),
    $453f58b911881f6f$var$load("7Omhy"),
    $453f58b911881f6f$var$load("kC80R"),
    $453f58b911881f6f$var$load("7EorR"),
    $453f58b911881f6f$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("dmhac", function(module, exports) {

let $9b9aa4c0f6448b36$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9b9aa4c0f6448b36$var$load("2YffH"),
    $9b9aa4c0f6448b36$var$load("8Kivm"),
    $9b9aa4c0f6448b36$var$load("fCnmZ"),
    $9b9aa4c0f6448b36$var$load("6bYkZ"),
    $9b9aa4c0f6448b36$var$load("iQ0Jm"),
    $9b9aa4c0f6448b36$var$load("coJiW"),
    $9b9aa4c0f6448b36$var$load("9MSTM"),
    $9b9aa4c0f6448b36$var$load("aYx1O"),
    $9b9aa4c0f6448b36$var$load("h4Nf7"),
    $9b9aa4c0f6448b36$var$load("7f9Fz"),
    $9b9aa4c0f6448b36$var$load("8YSo7"),
    $9b9aa4c0f6448b36$var$load("39eyQ"),
    $9b9aa4c0f6448b36$var$load("2spqH"),
    $9b9aa4c0f6448b36$var$load("gWSdF"),
    $9b9aa4c0f6448b36$var$load("6FuHS"),
    $9b9aa4c0f6448b36$var$load("eyaRC"),
    $9b9aa4c0f6448b36$var$load("g9CVe"),
    $9b9aa4c0f6448b36$var$load("aeEUI"),
    $9b9aa4c0f6448b36$var$load("hRUX7"),
    $9b9aa4c0f6448b36$var$load("g4oYs"),
    $9b9aa4c0f6448b36$var$load("6wr18"),
    $9b9aa4c0f6448b36$var$load("kjZZD"),
    $9b9aa4c0f6448b36$var$load("a71qb"),
    $9b9aa4c0f6448b36$var$load("awqCy"),
    $9b9aa4c0f6448b36$var$load("kHOMt"),
    $9b9aa4c0f6448b36$var$load("hhss7"),
    $9b9aa4c0f6448b36$var$load("61fdm"),
    $9b9aa4c0f6448b36$var$load("HRcBH"),
    $9b9aa4c0f6448b36$var$load("nbjnv"),
    $9b9aa4c0f6448b36$var$load("Wowvf"),
    $9b9aa4c0f6448b36$var$load("jlSv2"),
    $9b9aa4c0f6448b36$var$load("1UUrt"),
    $9b9aa4c0f6448b36$var$load("jSdjl"),
    $9b9aa4c0f6448b36$var$load("l2EUC"),
    $9b9aa4c0f6448b36$var$load("kWZnd"),
    $9b9aa4c0f6448b36$var$load("92LGf"),
    $9b9aa4c0f6448b36$var$load("let0D"),
    $9b9aa4c0f6448b36$var$load("joFPh"),
    $9b9aa4c0f6448b36$var$load("6M36W"),
    $9b9aa4c0f6448b36$var$load("ffEVr"),
    $9b9aa4c0f6448b36$var$load("kUbUu"),
    $9b9aa4c0f6448b36$var$load("2PePB"),
    $9b9aa4c0f6448b36$var$load("1W4KB"),
    $9b9aa4c0f6448b36$var$load("lnKog"),
    $9b9aa4c0f6448b36$var$load("9ftJe"),
    $9b9aa4c0f6448b36$var$load("7Omhy"),
    $9b9aa4c0f6448b36$var$load("kC80R"),
    $9b9aa4c0f6448b36$var$load("7EorR"),
    $9b9aa4c0f6448b36$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("hy6SH", function(module, exports) {

let $cc6af31ba5674fbc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cc6af31ba5674fbc$var$load("2YffH"),
    $cc6af31ba5674fbc$var$load("8Kivm"),
    $cc6af31ba5674fbc$var$load("fCnmZ"),
    $cc6af31ba5674fbc$var$load("6bYkZ"),
    $cc6af31ba5674fbc$var$load("iQ0Jm"),
    $cc6af31ba5674fbc$var$load("coJiW"),
    $cc6af31ba5674fbc$var$load("9MSTM"),
    $cc6af31ba5674fbc$var$load("aYx1O"),
    $cc6af31ba5674fbc$var$load("h4Nf7"),
    $cc6af31ba5674fbc$var$load("7f9Fz"),
    $cc6af31ba5674fbc$var$load("8YSo7"),
    $cc6af31ba5674fbc$var$load("39eyQ"),
    $cc6af31ba5674fbc$var$load("2spqH"),
    $cc6af31ba5674fbc$var$load("gWSdF"),
    $cc6af31ba5674fbc$var$load("6FuHS"),
    $cc6af31ba5674fbc$var$load("eyaRC"),
    $cc6af31ba5674fbc$var$load("g9CVe"),
    $cc6af31ba5674fbc$var$load("aeEUI"),
    $cc6af31ba5674fbc$var$load("hRUX7"),
    $cc6af31ba5674fbc$var$load("g4oYs"),
    $cc6af31ba5674fbc$var$load("6wr18"),
    $cc6af31ba5674fbc$var$load("kjZZD"),
    $cc6af31ba5674fbc$var$load("a71qb"),
    $cc6af31ba5674fbc$var$load("awqCy"),
    $cc6af31ba5674fbc$var$load("kHOMt"),
    $cc6af31ba5674fbc$var$load("hhss7"),
    $cc6af31ba5674fbc$var$load("61fdm"),
    $cc6af31ba5674fbc$var$load("HRcBH"),
    $cc6af31ba5674fbc$var$load("nbjnv"),
    $cc6af31ba5674fbc$var$load("Wowvf"),
    $cc6af31ba5674fbc$var$load("jlSv2"),
    $cc6af31ba5674fbc$var$load("1UUrt"),
    $cc6af31ba5674fbc$var$load("jSdjl"),
    $cc6af31ba5674fbc$var$load("l2EUC"),
    $cc6af31ba5674fbc$var$load("kWZnd"),
    $cc6af31ba5674fbc$var$load("92LGf"),
    $cc6af31ba5674fbc$var$load("let0D"),
    $cc6af31ba5674fbc$var$load("joFPh"),
    $cc6af31ba5674fbc$var$load("6M36W"),
    $cc6af31ba5674fbc$var$load("ffEVr"),
    $cc6af31ba5674fbc$var$load("kUbUu"),
    $cc6af31ba5674fbc$var$load("2PePB"),
    $cc6af31ba5674fbc$var$load("1W4KB"),
    $cc6af31ba5674fbc$var$load("lnKog"),
    $cc6af31ba5674fbc$var$load("9ftJe"),
    $cc6af31ba5674fbc$var$load("7Omhy"),
    $cc6af31ba5674fbc$var$load("kC80R"),
    $cc6af31ba5674fbc$var$load("7EorR"),
    $cc6af31ba5674fbc$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("jeVp9", function(module, exports) {

let $e01bda8093dee5a6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e01bda8093dee5a6$var$load("6FuHS"),
    $e01bda8093dee5a6$var$load("eyaRC"),
    $e01bda8093dee5a6$var$load("2YffH"),
    $e01bda8093dee5a6$var$load("2PePB"),
    $e01bda8093dee5a6$var$load("fCnmZ"),
    $e01bda8093dee5a6$var$load("6bYkZ"),
    $e01bda8093dee5a6$var$load("9MSTM"),
    $e01bda8093dee5a6$var$load("aYx1O"),
    $e01bda8093dee5a6$var$load("h4Nf7"),
    $e01bda8093dee5a6$var$load("7f9Fz"),
    $e01bda8093dee5a6$var$load("8YSo7"),
    $e01bda8093dee5a6$var$load("39eyQ"),
    $e01bda8093dee5a6$var$load("2spqH"),
    $e01bda8093dee5a6$var$load("gWSdF"),
    $e01bda8093dee5a6$var$load("g9CVe"),
    $e01bda8093dee5a6$var$load("aeEUI"),
    $e01bda8093dee5a6$var$load("hRUX7"),
    $e01bda8093dee5a6$var$load("g4oYs"),
    $e01bda8093dee5a6$var$load("6wr18"),
    $e01bda8093dee5a6$var$load("kjZZD"),
    $e01bda8093dee5a6$var$load("a71qb"),
    $e01bda8093dee5a6$var$load("awqCy"),
    $e01bda8093dee5a6$var$load("kHOMt"),
    $e01bda8093dee5a6$var$load("hhss7"),
    $e01bda8093dee5a6$var$load("61fdm"),
    $e01bda8093dee5a6$var$load("HRcBH"),
    $e01bda8093dee5a6$var$load("nbjnv"),
    $e01bda8093dee5a6$var$load("Wowvf"),
    $e01bda8093dee5a6$var$load("jlSv2"),
    $e01bda8093dee5a6$var$load("1UUrt"),
    $e01bda8093dee5a6$var$load("jSdjl"),
    $e01bda8093dee5a6$var$load("l2EUC"),
    $e01bda8093dee5a6$var$load("kWZnd"),
    $e01bda8093dee5a6$var$load("92LGf"),
    $e01bda8093dee5a6$var$load("let0D"),
    $e01bda8093dee5a6$var$load("joFPh"),
    $e01bda8093dee5a6$var$load("6M36W"),
    $e01bda8093dee5a6$var$load("1W4KB"),
    $e01bda8093dee5a6$var$load("ffEVr"),
    $e01bda8093dee5a6$var$load("kUbUu"),
    $e01bda8093dee5a6$var$load("9ftJe"),
    $e01bda8093dee5a6$var$load("7Omhy"),
    $e01bda8093dee5a6$var$load("kC80R"),
    $e01bda8093dee5a6$var$load("7EorR"),
    $e01bda8093dee5a6$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("2iVl7", function(module, exports) {

let $1ad9bda583e98510$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1ad9bda583e98510$var$load("6FuHS"),
    $1ad9bda583e98510$var$load("eyaRC"),
    $1ad9bda583e98510$var$load("2YffH"),
    $1ad9bda583e98510$var$load("2PePB"),
    $1ad9bda583e98510$var$load("fCnmZ"),
    $1ad9bda583e98510$var$load("6bYkZ"),
    $1ad9bda583e98510$var$load("9MSTM"),
    $1ad9bda583e98510$var$load("aYx1O"),
    $1ad9bda583e98510$var$load("h4Nf7"),
    $1ad9bda583e98510$var$load("7f9Fz"),
    $1ad9bda583e98510$var$load("8YSo7"),
    $1ad9bda583e98510$var$load("39eyQ"),
    $1ad9bda583e98510$var$load("2spqH"),
    $1ad9bda583e98510$var$load("gWSdF"),
    $1ad9bda583e98510$var$load("g9CVe"),
    $1ad9bda583e98510$var$load("aeEUI"),
    $1ad9bda583e98510$var$load("hRUX7"),
    $1ad9bda583e98510$var$load("g4oYs"),
    $1ad9bda583e98510$var$load("6wr18"),
    $1ad9bda583e98510$var$load("kjZZD"),
    $1ad9bda583e98510$var$load("a71qb"),
    $1ad9bda583e98510$var$load("awqCy"),
    $1ad9bda583e98510$var$load("kHOMt"),
    $1ad9bda583e98510$var$load("hhss7"),
    $1ad9bda583e98510$var$load("61fdm"),
    $1ad9bda583e98510$var$load("HRcBH"),
    $1ad9bda583e98510$var$load("nbjnv"),
    $1ad9bda583e98510$var$load("Wowvf"),
    $1ad9bda583e98510$var$load("jlSv2"),
    $1ad9bda583e98510$var$load("1UUrt"),
    $1ad9bda583e98510$var$load("jSdjl"),
    $1ad9bda583e98510$var$load("l2EUC"),
    $1ad9bda583e98510$var$load("kWZnd"),
    $1ad9bda583e98510$var$load("92LGf"),
    $1ad9bda583e98510$var$load("let0D"),
    $1ad9bda583e98510$var$load("joFPh"),
    $1ad9bda583e98510$var$load("6M36W"),
    $1ad9bda583e98510$var$load("1W4KB"),
    $1ad9bda583e98510$var$load("ffEVr"),
    $1ad9bda583e98510$var$load("kUbUu"),
    $1ad9bda583e98510$var$load("9ftJe"),
    $1ad9bda583e98510$var$load("7Omhy"),
    $1ad9bda583e98510$var$load("kC80R"),
    $1ad9bda583e98510$var$load("7EorR"),
    $1ad9bda583e98510$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("a83DI", function(module, exports) {

let $75fd797e23496cfc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $75fd797e23496cfc$var$load("6FuHS"),
    $75fd797e23496cfc$var$load("eyaRC"),
    $75fd797e23496cfc$var$load("2YffH"),
    $75fd797e23496cfc$var$load("2PePB"),
    $75fd797e23496cfc$var$load("fCnmZ"),
    $75fd797e23496cfc$var$load("6bYkZ"),
    $75fd797e23496cfc$var$load("9MSTM"),
    $75fd797e23496cfc$var$load("aYx1O"),
    $75fd797e23496cfc$var$load("h4Nf7"),
    $75fd797e23496cfc$var$load("7f9Fz"),
    $75fd797e23496cfc$var$load("8YSo7"),
    $75fd797e23496cfc$var$load("39eyQ"),
    $75fd797e23496cfc$var$load("2spqH"),
    $75fd797e23496cfc$var$load("gWSdF"),
    $75fd797e23496cfc$var$load("g9CVe"),
    $75fd797e23496cfc$var$load("aeEUI"),
    $75fd797e23496cfc$var$load("hRUX7"),
    $75fd797e23496cfc$var$load("g4oYs"),
    $75fd797e23496cfc$var$load("6wr18"),
    $75fd797e23496cfc$var$load("kjZZD"),
    $75fd797e23496cfc$var$load("a71qb"),
    $75fd797e23496cfc$var$load("awqCy"),
    $75fd797e23496cfc$var$load("kHOMt"),
    $75fd797e23496cfc$var$load("hhss7"),
    $75fd797e23496cfc$var$load("61fdm"),
    $75fd797e23496cfc$var$load("HRcBH"),
    $75fd797e23496cfc$var$load("nbjnv"),
    $75fd797e23496cfc$var$load("Wowvf"),
    $75fd797e23496cfc$var$load("jlSv2"),
    $75fd797e23496cfc$var$load("1UUrt"),
    $75fd797e23496cfc$var$load("jSdjl"),
    $75fd797e23496cfc$var$load("l2EUC"),
    $75fd797e23496cfc$var$load("kWZnd"),
    $75fd797e23496cfc$var$load("92LGf"),
    $75fd797e23496cfc$var$load("let0D"),
    $75fd797e23496cfc$var$load("joFPh"),
    $75fd797e23496cfc$var$load("6M36W"),
    $75fd797e23496cfc$var$load("1W4KB"),
    $75fd797e23496cfc$var$load("ffEVr"),
    $75fd797e23496cfc$var$load("kUbUu"),
    $75fd797e23496cfc$var$load("9ftJe"),
    $75fd797e23496cfc$var$load("7Omhy"),
    $75fd797e23496cfc$var$load("kC80R"),
    $75fd797e23496cfc$var$load("7EorR"),
    $75fd797e23496cfc$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("iOId4", function(module, exports) {

let $db2f30a67ea7f50d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $db2f30a67ea7f50d$var$load("6FuHS"),
    $db2f30a67ea7f50d$var$load("eyaRC"),
    $db2f30a67ea7f50d$var$load("2YffH"),
    $db2f30a67ea7f50d$var$load("fCnmZ"),
    $db2f30a67ea7f50d$var$load("6bYkZ"),
    $db2f30a67ea7f50d$var$load("9MSTM"),
    $db2f30a67ea7f50d$var$load("aYx1O"),
    $db2f30a67ea7f50d$var$load("h4Nf7"),
    $db2f30a67ea7f50d$var$load("7f9Fz"),
    $db2f30a67ea7f50d$var$load("8YSo7"),
    $db2f30a67ea7f50d$var$load("39eyQ"),
    $db2f30a67ea7f50d$var$load("2spqH"),
    $db2f30a67ea7f50d$var$load("gWSdF"),
    $db2f30a67ea7f50d$var$load("g9CVe"),
    $db2f30a67ea7f50d$var$load("aeEUI"),
    $db2f30a67ea7f50d$var$load("hRUX7"),
    $db2f30a67ea7f50d$var$load("g4oYs"),
    $db2f30a67ea7f50d$var$load("6wr18"),
    $db2f30a67ea7f50d$var$load("kjZZD"),
    $db2f30a67ea7f50d$var$load("a71qb"),
    $db2f30a67ea7f50d$var$load("awqCy"),
    $db2f30a67ea7f50d$var$load("kHOMt"),
    $db2f30a67ea7f50d$var$load("hhss7"),
    $db2f30a67ea7f50d$var$load("61fdm"),
    $db2f30a67ea7f50d$var$load("HRcBH"),
    $db2f30a67ea7f50d$var$load("nbjnv"),
    $db2f30a67ea7f50d$var$load("Wowvf"),
    $db2f30a67ea7f50d$var$load("jlSv2"),
    $db2f30a67ea7f50d$var$load("1UUrt"),
    $db2f30a67ea7f50d$var$load("jSdjl"),
    $db2f30a67ea7f50d$var$load("l2EUC"),
    $db2f30a67ea7f50d$var$load("kWZnd"),
    $db2f30a67ea7f50d$var$load("92LGf"),
    $db2f30a67ea7f50d$var$load("let0D"),
    $db2f30a67ea7f50d$var$load("joFPh"),
    $db2f30a67ea7f50d$var$load("6M36W"),
    $db2f30a67ea7f50d$var$load("ffEVr"),
    $db2f30a67ea7f50d$var$load("kUbUu"),
    $db2f30a67ea7f50d$var$load("2PePB"),
    $db2f30a67ea7f50d$var$load("1W4KB"),
    $db2f30a67ea7f50d$var$load("lnKog"),
    $db2f30a67ea7f50d$var$load("9ftJe"),
    $db2f30a67ea7f50d$var$load("7Omhy"),
    $db2f30a67ea7f50d$var$load("kC80R"),
    $db2f30a67ea7f50d$var$load("7EorR"),
    $db2f30a67ea7f50d$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("lWIx1", function(module, exports) {

let $ffa18ecb1af2190b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ffa18ecb1af2190b$var$load("2YffH"),
    $ffa18ecb1af2190b$var$load("fCnmZ"),
    $ffa18ecb1af2190b$var$load("6bYkZ"),
    $ffa18ecb1af2190b$var$load("coJiW"),
    $ffa18ecb1af2190b$var$load("9MSTM"),
    $ffa18ecb1af2190b$var$load("aYx1O"),
    $ffa18ecb1af2190b$var$load("h4Nf7"),
    $ffa18ecb1af2190b$var$load("7f9Fz"),
    $ffa18ecb1af2190b$var$load("8YSo7"),
    $ffa18ecb1af2190b$var$load("39eyQ"),
    $ffa18ecb1af2190b$var$load("2spqH"),
    $ffa18ecb1af2190b$var$load("gWSdF"),
    $ffa18ecb1af2190b$var$load("6FuHS"),
    $ffa18ecb1af2190b$var$load("eyaRC"),
    $ffa18ecb1af2190b$var$load("g9CVe"),
    $ffa18ecb1af2190b$var$load("aeEUI"),
    $ffa18ecb1af2190b$var$load("hRUX7"),
    $ffa18ecb1af2190b$var$load("g4oYs"),
    $ffa18ecb1af2190b$var$load("6wr18"),
    $ffa18ecb1af2190b$var$load("kjZZD"),
    $ffa18ecb1af2190b$var$load("a71qb"),
    $ffa18ecb1af2190b$var$load("dTsOE"),
    $ffa18ecb1af2190b$var$load("awqCy"),
    $ffa18ecb1af2190b$var$load("kHOMt"),
    $ffa18ecb1af2190b$var$load("hhss7"),
    $ffa18ecb1af2190b$var$load("61fdm"),
    $ffa18ecb1af2190b$var$load("HRcBH"),
    $ffa18ecb1af2190b$var$load("nbjnv"),
    $ffa18ecb1af2190b$var$load("Wowvf"),
    $ffa18ecb1af2190b$var$load("jlSv2"),
    $ffa18ecb1af2190b$var$load("1UUrt"),
    $ffa18ecb1af2190b$var$load("jSdjl"),
    $ffa18ecb1af2190b$var$load("l2EUC"),
    $ffa18ecb1af2190b$var$load("kWZnd"),
    $ffa18ecb1af2190b$var$load("92LGf"),
    $ffa18ecb1af2190b$var$load("let0D"),
    $ffa18ecb1af2190b$var$load("joFPh"),
    $ffa18ecb1af2190b$var$load("6M36W"),
    $ffa18ecb1af2190b$var$load("ffEVr"),
    $ffa18ecb1af2190b$var$load("kUbUu"),
    $ffa18ecb1af2190b$var$load("2PePB"),
    $ffa18ecb1af2190b$var$load("1W4KB"),
    $ffa18ecb1af2190b$var$load("lnKog"),
    $ffa18ecb1af2190b$var$load("9ftJe"),
    $ffa18ecb1af2190b$var$load("7Omhy"),
    $ffa18ecb1af2190b$var$load("kC80R"),
    $ffa18ecb1af2190b$var$load("7EorR"),
    $ffa18ecb1af2190b$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("kxJWh", function(module, exports) {

let $ef4a863aff9916b9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ef4a863aff9916b9$var$load("2YffH"),
    $ef4a863aff9916b9$var$load("fCnmZ"),
    $ef4a863aff9916b9$var$load("6bYkZ"),
    $ef4a863aff9916b9$var$load("coJiW"),
    $ef4a863aff9916b9$var$load("9MSTM"),
    $ef4a863aff9916b9$var$load("aYx1O"),
    $ef4a863aff9916b9$var$load("h4Nf7"),
    $ef4a863aff9916b9$var$load("7f9Fz"),
    $ef4a863aff9916b9$var$load("8YSo7"),
    $ef4a863aff9916b9$var$load("39eyQ"),
    $ef4a863aff9916b9$var$load("2spqH"),
    $ef4a863aff9916b9$var$load("gWSdF"),
    $ef4a863aff9916b9$var$load("6FuHS"),
    $ef4a863aff9916b9$var$load("eyaRC"),
    $ef4a863aff9916b9$var$load("g9CVe"),
    $ef4a863aff9916b9$var$load("aeEUI"),
    $ef4a863aff9916b9$var$load("hRUX7"),
    $ef4a863aff9916b9$var$load("g4oYs"),
    $ef4a863aff9916b9$var$load("6wr18"),
    $ef4a863aff9916b9$var$load("kjZZD"),
    $ef4a863aff9916b9$var$load("a71qb"),
    $ef4a863aff9916b9$var$load("dTsOE"),
    $ef4a863aff9916b9$var$load("awqCy"),
    $ef4a863aff9916b9$var$load("kHOMt"),
    $ef4a863aff9916b9$var$load("hhss7"),
    $ef4a863aff9916b9$var$load("61fdm"),
    $ef4a863aff9916b9$var$load("HRcBH"),
    $ef4a863aff9916b9$var$load("nbjnv"),
    $ef4a863aff9916b9$var$load("Wowvf"),
    $ef4a863aff9916b9$var$load("jlSv2"),
    $ef4a863aff9916b9$var$load("1UUrt"),
    $ef4a863aff9916b9$var$load("jSdjl"),
    $ef4a863aff9916b9$var$load("l2EUC"),
    $ef4a863aff9916b9$var$load("kWZnd"),
    $ef4a863aff9916b9$var$load("92LGf"),
    $ef4a863aff9916b9$var$load("let0D"),
    $ef4a863aff9916b9$var$load("joFPh"),
    $ef4a863aff9916b9$var$load("6M36W"),
    $ef4a863aff9916b9$var$load("ffEVr"),
    $ef4a863aff9916b9$var$load("kUbUu"),
    $ef4a863aff9916b9$var$load("2PePB"),
    $ef4a863aff9916b9$var$load("1W4KB"),
    $ef4a863aff9916b9$var$load("lnKog"),
    $ef4a863aff9916b9$var$load("9ftJe"),
    $ef4a863aff9916b9$var$load("7Omhy"),
    $ef4a863aff9916b9$var$load("kC80R"),
    $ef4a863aff9916b9$var$load("7EorR"),
    $ef4a863aff9916b9$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("acptf", function(module, exports) {

let $76cec858a237054e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $76cec858a237054e$var$load("6FuHS"),
    $76cec858a237054e$var$load("eyaRC"),
    $76cec858a237054e$var$load("2YffH"),
    $76cec858a237054e$var$load("2PePB"),
    $76cec858a237054e$var$load("fCnmZ"),
    $76cec858a237054e$var$load("6bYkZ"),
    $76cec858a237054e$var$load("9MSTM"),
    $76cec858a237054e$var$load("aYx1O"),
    $76cec858a237054e$var$load("h4Nf7"),
    $76cec858a237054e$var$load("7f9Fz"),
    $76cec858a237054e$var$load("8YSo7"),
    $76cec858a237054e$var$load("39eyQ"),
    $76cec858a237054e$var$load("2spqH"),
    $76cec858a237054e$var$load("gWSdF"),
    $76cec858a237054e$var$load("g9CVe"),
    $76cec858a237054e$var$load("aeEUI"),
    $76cec858a237054e$var$load("hRUX7"),
    $76cec858a237054e$var$load("g4oYs"),
    $76cec858a237054e$var$load("6wr18"),
    $76cec858a237054e$var$load("kjZZD"),
    $76cec858a237054e$var$load("a71qb"),
    $76cec858a237054e$var$load("awqCy"),
    $76cec858a237054e$var$load("kHOMt"),
    $76cec858a237054e$var$load("hhss7"),
    $76cec858a237054e$var$load("61fdm"),
    $76cec858a237054e$var$load("HRcBH"),
    $76cec858a237054e$var$load("nbjnv"),
    $76cec858a237054e$var$load("Wowvf"),
    $76cec858a237054e$var$load("jlSv2"),
    $76cec858a237054e$var$load("1UUrt"),
    $76cec858a237054e$var$load("jSdjl"),
    $76cec858a237054e$var$load("l2EUC"),
    $76cec858a237054e$var$load("kWZnd"),
    $76cec858a237054e$var$load("92LGf"),
    $76cec858a237054e$var$load("let0D"),
    $76cec858a237054e$var$load("joFPh"),
    $76cec858a237054e$var$load("6M36W"),
    $76cec858a237054e$var$load("1W4KB"),
    $76cec858a237054e$var$load("ffEVr"),
    $76cec858a237054e$var$load("kUbUu"),
    $76cec858a237054e$var$load("9ftJe"),
    $76cec858a237054e$var$load("7Omhy"),
    $76cec858a237054e$var$load("kC80R"),
    $76cec858a237054e$var$load("7EorR"),
    $76cec858a237054e$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("kkEob", function(module, exports) {

let $ecd5014ff8a0c551$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ecd5014ff8a0c551$var$load("6FuHS"),
    $ecd5014ff8a0c551$var$load("eyaRC"),
    $ecd5014ff8a0c551$var$load("2YffH"),
    $ecd5014ff8a0c551$var$load("fCnmZ"),
    $ecd5014ff8a0c551$var$load("6bYkZ"),
    $ecd5014ff8a0c551$var$load("9MSTM"),
    $ecd5014ff8a0c551$var$load("aYx1O"),
    $ecd5014ff8a0c551$var$load("h4Nf7"),
    $ecd5014ff8a0c551$var$load("7f9Fz"),
    $ecd5014ff8a0c551$var$load("8YSo7"),
    $ecd5014ff8a0c551$var$load("39eyQ"),
    $ecd5014ff8a0c551$var$load("2spqH"),
    $ecd5014ff8a0c551$var$load("gWSdF"),
    $ecd5014ff8a0c551$var$load("g9CVe"),
    $ecd5014ff8a0c551$var$load("aeEUI"),
    $ecd5014ff8a0c551$var$load("hRUX7"),
    $ecd5014ff8a0c551$var$load("g4oYs"),
    $ecd5014ff8a0c551$var$load("6wr18"),
    $ecd5014ff8a0c551$var$load("kjZZD"),
    $ecd5014ff8a0c551$var$load("a71qb"),
    $ecd5014ff8a0c551$var$load("awqCy"),
    $ecd5014ff8a0c551$var$load("kHOMt"),
    $ecd5014ff8a0c551$var$load("hhss7"),
    $ecd5014ff8a0c551$var$load("61fdm"),
    $ecd5014ff8a0c551$var$load("HRcBH"),
    $ecd5014ff8a0c551$var$load("nbjnv"),
    $ecd5014ff8a0c551$var$load("Wowvf"),
    $ecd5014ff8a0c551$var$load("jlSv2"),
    $ecd5014ff8a0c551$var$load("1UUrt"),
    $ecd5014ff8a0c551$var$load("jSdjl"),
    $ecd5014ff8a0c551$var$load("l2EUC"),
    $ecd5014ff8a0c551$var$load("kWZnd"),
    $ecd5014ff8a0c551$var$load("92LGf"),
    $ecd5014ff8a0c551$var$load("let0D"),
    $ecd5014ff8a0c551$var$load("joFPh"),
    $ecd5014ff8a0c551$var$load("6M36W"),
    $ecd5014ff8a0c551$var$load("ffEVr"),
    $ecd5014ff8a0c551$var$load("kUbUu"),
    $ecd5014ff8a0c551$var$load("2PePB"),
    $ecd5014ff8a0c551$var$load("1W4KB"),
    $ecd5014ff8a0c551$var$load("lnKog"),
    $ecd5014ff8a0c551$var$load("9ftJe"),
    $ecd5014ff8a0c551$var$load("7Omhy"),
    $ecd5014ff8a0c551$var$load("kC80R"),
    $ecd5014ff8a0c551$var$load("7EorR"),
    $ecd5014ff8a0c551$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("ayUlM", function(module, exports) {

let $7b08ca54c918f6eb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7b08ca54c918f6eb$var$load("6FuHS"),
    $7b08ca54c918f6eb$var$load("eyaRC"),
    $7b08ca54c918f6eb$var$load("2YffH"),
    $7b08ca54c918f6eb$var$load("fCnmZ"),
    $7b08ca54c918f6eb$var$load("6bYkZ"),
    $7b08ca54c918f6eb$var$load("9MSTM"),
    $7b08ca54c918f6eb$var$load("aYx1O"),
    $7b08ca54c918f6eb$var$load("h4Nf7"),
    $7b08ca54c918f6eb$var$load("7f9Fz"),
    $7b08ca54c918f6eb$var$load("8YSo7"),
    $7b08ca54c918f6eb$var$load("39eyQ"),
    $7b08ca54c918f6eb$var$load("2spqH"),
    $7b08ca54c918f6eb$var$load("gWSdF"),
    $7b08ca54c918f6eb$var$load("g9CVe"),
    $7b08ca54c918f6eb$var$load("aeEUI"),
    $7b08ca54c918f6eb$var$load("hRUX7"),
    $7b08ca54c918f6eb$var$load("g4oYs"),
    $7b08ca54c918f6eb$var$load("6wr18"),
    $7b08ca54c918f6eb$var$load("kjZZD"),
    $7b08ca54c918f6eb$var$load("a71qb"),
    $7b08ca54c918f6eb$var$load("awqCy"),
    $7b08ca54c918f6eb$var$load("kHOMt"),
    $7b08ca54c918f6eb$var$load("hhss7"),
    $7b08ca54c918f6eb$var$load("61fdm"),
    $7b08ca54c918f6eb$var$load("HRcBH"),
    $7b08ca54c918f6eb$var$load("nbjnv"),
    $7b08ca54c918f6eb$var$load("Wowvf"),
    $7b08ca54c918f6eb$var$load("jlSv2"),
    $7b08ca54c918f6eb$var$load("1UUrt"),
    $7b08ca54c918f6eb$var$load("jSdjl"),
    $7b08ca54c918f6eb$var$load("l2EUC"),
    $7b08ca54c918f6eb$var$load("kWZnd"),
    $7b08ca54c918f6eb$var$load("92LGf"),
    $7b08ca54c918f6eb$var$load("let0D"),
    $7b08ca54c918f6eb$var$load("joFPh"),
    $7b08ca54c918f6eb$var$load("6M36W"),
    $7b08ca54c918f6eb$var$load("ffEVr"),
    $7b08ca54c918f6eb$var$load("kUbUu"),
    $7b08ca54c918f6eb$var$load("2PePB"),
    $7b08ca54c918f6eb$var$load("1W4KB"),
    $7b08ca54c918f6eb$var$load("lnKog"),
    $7b08ca54c918f6eb$var$load("9ftJe"),
    $7b08ca54c918f6eb$var$load("7Omhy"),
    $7b08ca54c918f6eb$var$load("kC80R"),
    $7b08ca54c918f6eb$var$load("7EorR"),
    $7b08ca54c918f6eb$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("bSdpv"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("bSdpv", function(module, exports) {

let $8a4f23dbcd20a889$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8a4f23dbcd20a889$var$load("2PePB"),
    $8a4f23dbcd20a889$var$load("1W4KB"),
    $8a4f23dbcd20a889$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("c54hr", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $367766f6f044c46b$var$initialState = {
    isMenuOpen: false,
    isCloseMenuDisabled: false
};
const $367766f6f044c46b$var$actions = {
    setIsMenuOpen: (isMenuOpen)=>({ setState: setState })=>{
            setState({
                isMenuOpen: isMenuOpen
            });
        },
    setIsCloseMenuDisabled: (isCloseMenuDisabled)=>({ setState: setState })=>{
            setState({
                isCloseMenuDisabled: isCloseMenuDisabled
            });
        }
};
const $367766f6f044c46b$var$Store = (0, $1P1Tu.createStore)({
    initialState: $367766f6f044c46b$var$initialState,
    actions: $367766f6f044c46b$var$actions,
    name: 'more-actions-menu-store'
});
const $367766f6f044c46b$export$14d00db016c2b3ef = (0, $9zUhf.createStateHook)($367766f6f044c46b$var$Store);
const $367766f6f044c46b$export$1f1f8c486fa8a1cb = (0, $9zUhf.createActionsHook)($367766f6f044c46b$var$Store);
module.exports["useMoreActionsMenuState"] = $367766f6f044c46b$export$14d00db016c2b3ef;
module.exports["useMoreActionsMenuActions"] = $367766f6f044c46b$export$1f1f8c486fa8a1cb;

});

parcelRegister("9fBoq", function(module, exports) {
parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $1Aku8.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $1Aku8.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("1c598", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");
var $9dbGT = parcelRequire("9dbGT");

parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");


});

parcelRegister("i3Ypo", function(module, exports) {
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");


var $1Aku8 = parcelRequire("1Aku8");


var $6sM2K = parcelRequire("6sM2K");


var $2JC3k = parcelRequire("2JC3k");


});

parcelRegister("9dbGT", function(module, exports) {
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];
module.exports["MarkupRecursiveList"] = $1ec3e8240f57817b$export$3b98ab6402702476;
module.exports["MarkupList"] = $1ec3e8240f57817b$export$3ee8c58bb87b9685;

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
module.exports["ExtensionEnvironment"] = $d977f97374f9d2c9$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $d977f97374f9d2c9$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $d977f97374f9d2c9$export$f06ffa3aa6bfec95;

});

parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");


var $kg3OT = parcelRequire("kg3OT");


var $gUjm2 = parcelRequire("gUjm2");


});

parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("9MrOn", function(module, exports) {
/* ContentToolsButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $9VJDA = parcelRequire("9VJDA");


var $1qfLF = parcelRequire("1qfLF");


var $52EPl = parcelRequire("52EPl");

const $43c0d8bb08806c39$var$NOOP = ()=>{};
const $43c0d8bb08806c39$var$i18n = (0, $cgtv4.defineMessages)({
    triggerLabel: {
        id: "content-tools.more.icon.label",
        defaultMessage: "More actions"
    }
});
const $43c0d8bb08806c39$var$dropdownMenuCollaboratorStyle = null;
const $43c0d8bb08806c39$var$dropdownMenuNonCollaboratorStyle = null;
const $43c0d8bb08806c39$var$ContentToolsButtonComponent = ({ isDisabled: isDisabled, isOpen: isOpen = false, onOpenChange: onOpenChange = $43c0d8bb08806c39$var$NOOP, onPositioned: onPositioned = $43c0d8bb08806c39$var$NOOP, children: children, isExternalCollaborator: isExternalCollaborator = false })=>{
    'use no memo';
    const intl = (0, $8C5kA.default)();
    const [drodownMenuMaxHeight, setDropdownMenuMaxHeight] = (0, $42omo.useState)('auto');
    const dropdownMenuContainerRef = (0, $42omo.useRef)(null);
    const handleOnOpenChange = (obj)=>{
        onOpenChange(obj);
        if (obj.isOpen) {
            const distanceFromTop = dropdownMenuContainerRef.current?.getBoundingClientRect().bottom ?? 0;
            const availableHeight = window.innerHeight - distanceFromTop - 16;
            setDropdownMenuMaxHeight(`${availableHeight}px`);
        }
    };
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-id": "content-tools-dropdown-menu-container",
        "data-test-id": "content-tools-dropdown-menu-container",
        "data-testid": "content-tools-dropdown-menu-container",
        ref: dropdownMenuContainerRef,
        className: (0, $gMc0m.default)([
            "_18u019bv _1ul91tcg",
            isExternalCollaborator && "_18u0idpf _1ul91tcg"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
        testId: "content-tools-dropdown-menu",
        appearance: "tall",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
                ...props,
                "data-id": "page-more-action-button",
                "data-test-id": "page-more-action-button",
                id: "tools-menu-trigger",
                label: intl.formatMessage($43c0d8bb08806c39$var$i18n.triggerLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: isDisabled
            }),
        placement: "bottom-end",
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        shouldFlip: false,
        onPositioned: onPositioned,
        shouldRenderToParent: true
    }, /*#__PURE__*/ $42omo.createElement("div", {
        style: {
            maxHeight: drodownMenuMaxHeight
        }
    }, children || null)));
};
$43c0d8bb08806c39$var$ContentToolsButtonComponent.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isExternalCollaborator: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    onPositioned: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
};
const $43c0d8bb08806c39$export$f221d384e5b0f4c3 = /*#__PURE__*/ (0, $42omo.memo)($43c0d8bb08806c39$var$ContentToolsButtonComponent);
module.exports["ContentToolsButton"] = $43c0d8bb08806c39$export$f221d384e5b0f4c3;

});


//# sourceMappingURL=ForgeContentTools.4a32a7a3.js.map
